import { usePlanCreatorContext } from "@components/PlanCreator/PlanCreatorContext";
import dayjs, { Dayjs } from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { PlanTimePropsI } from "./PlanTime.props";
import { dev } from "@utils/dev";
import { IPlanRange } from "@services/getMinerList";
import { error } from "console";

const IN_MINUTES = 1 * 60 * 1000;
const IN_HOURS = 1 * 60 * IN_MINUTES;
const IN_DAY = 24 * IN_HOURS;

function getDateForTime(time: string): Date {
  // "04:00" -> Date
  const result = new Date();
  result.setSeconds(0);
  result.setMilliseconds(0);
  const hhmm = time.split(":");
  if (hhmm.length === 2) {
    result.setHours(parseInt(hhmm[0]));
    result.setMinutes(parseInt(hhmm[1]));
  }
  return result;
}

function hhmmToDayJs(hhmm: string): Dayjs | null {
  if (hhmm === "") return null;
  return dayjs(getDateForTime(hhmm));
}

export const usePlanTimeControl = (props: PlanTimePropsI) => {

  //console.log("usePlanTimeControl props:", props);

  const { updatePeriodByIndex } = usePlanCreatorContext();
  const [errors, setErrors] = useState<string[]>([]);
  const [openStart, setOpenStart] = useState(false);
  const [openEnd, setOpenEnd] = useState(false);
  const [time, setTime] = useState<[Dayjs | null, Dayjs | null]>([
    hhmmToDayJs("00:00"),
    hhmmToDayJs("23:59"),
  ]);

  // useEffect(() => {
  //   if (periods.length > props.idx) {
  //     const current = periods[props.idx];
  //     if (current) {
  //       setTime([
  //         hhmmToDayJs(current[0]),
  //         hhmmToDayJs(current[1])
  //       ]);
  //     }
  //   }
  // }, [periods]);

  useEffect(() => {
    if (props.value && props.value.length > 1) {
      setTime([
        hhmmToDayJs(props.value[0]),
        hhmmToDayJs(props.value[1])
      ]);
    }
  }, [props]);

  useEffect(() => {
    if (time[0] && time[1] && time[0].isAfter(time[1])) {
      setErrors(["manage.plan_info.error_time_after_time"]);
    } else {
      setErrors([]);
    }
  }, [time]);

  const onChangeTime = useCallback((t: Dayjs | null, i: number) => {
    const newTime: [Dayjs | null, Dayjs | null] = [
      time[0]?.clone() ?? null,
      time[1]?.clone() ?? null
    ];
    if (newTime[i] === null && t === null) {
      newTime[i] = dayjs();
    } else {
      newTime[i] = t?.clone() ?? null;
    }
    setTime(newTime);
    updatePeriodByIndex(props.idx, [
      newTime[0]?.format("HH:mm") ?? "",
      newTime[1]?.format("HH:mm") ?? "",
    ]);
    // setPeriods(prev => {
    //   const result = prev.map((item, i) => {
    //     if (i === props.idx) {
    //       return {
    //         ...item,
    //         time: [
    //           newTime[0]?.format("HH:mm") ?? "",
    //           newTime[1]?.format("HH:mm") ?? "",
    //         ]
    //       } as IPlanRange;
    //     } else {
    //       return item;
    //     }
    //   });
    //   return result;
    // });
  }, [updatePeriodByIndex, time]);

  // const setNow = useCallback((idx: number) => {
  //   const newTime: [Dayjs | null, Dayjs | null] = [
  //     time[0]?.clone() ?? null,
  //     time[1]?.clone() ?? null
  //   ];
  //   setTime(dayjs())
  // }, [time]);

  function getFromFieldTimePickerDisabledTimes(
    toHour: number,
    toMinute: number
  ) {
    return {
      disabledHours: () => {
        const hours: number[] = [];
        for (let h = toHour + 1; h < 24; h++) {
          hours.push(h);
        }
        return hours;
      },

      disabledMinutes: (selectedHour: number) => {
        if (selectedHour > toHour) {
          // Все минуты недоступны, если час больше toHour
          const allMinutes: number[] = [];
          for (let m = 0; m < 60; m++) {
            allMinutes.push(m);
          }
          return allMinutes;
        }

        if (selectedHour === toHour) {
          // Недоступны минуты от toMinute до 59
          const minutes: number[] = [];
          for (let m = toMinute; m < 60; m++) {
            minutes.push(m);
          }
          return minutes;
        }

        // Все минуты доступны
        return [];
      }
    };
  }

  function getToFieldTimePickerDisabledTimes(
    fromHour: number,
    fromMinute: number
  ) {
    //const { hour: fromHour, minute: fromMinute } = fromTime;

    return {
      disabledHours: () => {
        const hours: number[] = [];
        for (let h = 0; h < fromHour; h++) {
          hours.push(h);
        }
        return hours;
      },

      disabledMinutes: (selectedHour: number) => {
        if (selectedHour < fromHour) {
          // Все минуты недоступны, если час меньше fromHour
          const allMinutes: number[] = [];
          for (let m = 0; m < 60; m++) {
            allMinutes.push(m);
          }
          return allMinutes;
        }

        if (selectedHour === fromHour) {
          // Недоступны минуты от 0 до fromMinute
          const minutes: number[] = [];
          for (let m = 0; m <= fromMinute; m++) {
            minutes.push(m);
          }
          return minutes;
        }

        // Все минуты доступны
        return [];
      }
    };
  }

  return {
    time,
    openStart,
    openEnd,
    errors,
    setOpenStart,
    setOpenEnd,
    onChangeTime,
    getFromFieldTimePickerDisabledTimes,
    getToFieldTimePickerDisabledTimes,
  };
};
